import { useLingui } from '@lingui/react/macro';
import React, { useCallback } from 'react';
import history from 'modules/overlay-canvas/addons/history';
import { ShapeEnum } from 'modules/overlay-canvas/addons/placeholders/complex/indicators-row';
import UDText from 'ud-ui/components/text';

import Selector from 'modules/template-editor/ui/components/elements/selector';
import { useEditorManager } from 'modules/template-editor/ui/context';

interface IProps {
  onChange: (shape: ShapeEnum) => void;
  value: ShapeEnum;
}

function ChoosingShape(props: IProps) {
  const { t } = useLingui();
  const options = [
    { label: t`Круг`, value: ShapeEnum.CIRCLE },
    { label: t`Прямоугольник`, value: ShapeEnum.RECTANGLE },
  ];
  const { onChange, value } = props;
  const manager = useEditorManager();

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <UDText type={'caption-1'}>{t`Форма индикатора`}</UDText>
      <Selector
        onFocus={onFocusField}
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingShape;
